module.exports = __webpack_public_path__ + "img/cnb_campagne_ftv_2022.3d16107f.jpg";